let fields = [];
fields.push({ size: "1/2", type: "input", attribute: "plate", validation: "required" });
fields.push({ size: "1/2", type: "input", attribute: "brand" });
fields.push({ size: "1/2", type: "input", attribute: "model" });
fields.push({ size: "1/2", type: "input", attribute: "color" });

export default fields;